import { Typography } from '@mui/material';
import styled from 'styled-components';

export const StyledSubText = styled(Typography)`
	color: #768d95;
	font-size: 12px;
`;
